const BODY_MAIL_TYPES = {
  invite: "invite",
  accountDeactivated: "accountDeactivated",
  accountActivated: "accountActivated",
  accountDeactivatedByAdmin: "accountDeactivatedByAdmin",
  passwordReset: "passwordReset",
  passwordResetInactive: "passwordResetInactive",
  newReport: "newReport",
  formReceived: "formReceived",
  formRelaunched: "formRelaunched",
  formRecall: "formRecall",
  formSubmitted: "formSubmitted"
}
export default BODY_MAIL_TYPES
